import React from 'react';

const IcRegularCustomer = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
      <path
        d='M10.4468 0.835083C13.4122 0.835272 15.8159 3.23971 15.8159 6.2052C15.8158 7.79198 15.1271 9.21736 14.0327 10.2003C16.6618 10.584 18.6811 12.8476 18.6812 15.5831V17.3517C18.6811 18.3531 17.869 19.1649 16.8677 19.1652H4.13232C3.13099 19.1649 2.3189 18.3531 2.31885 17.3517V15.5831C2.31889 12.8792 4.29186 10.636 6.87646 10.214C5.77288 9.2306 5.07677 7.79964 5.07666 6.2052C5.07666 3.23959 7.48117 0.835083 10.4468 0.835083ZM7.76025 11.9562C5.75713 11.9562 4.13238 13.58 4.13232 15.5831V17.3517H16.8677V15.5831C16.8676 13.58 15.2429 11.9562 13.2397 11.9562H7.76025ZM10.4468 2.64856C8.48275 2.64856 6.89014 4.24117 6.89014 6.2052C6.89033 8.16906 8.48287 9.76086 10.4468 9.76086C12.4105 9.76067 14.0022 8.16895 14.0024 6.2052C14.0024 4.24129 12.4106 2.64875 10.4468 2.64856Z'
        fill='#4F1787'
      />
    </svg>
  );
};

export default IcRegularCustomer;
